import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

import dataReducer from './reducers/dataReducer'
import clienteReducer from './reducers/clienteReducer'
import userReducer from './reducers/userReducer'

const initialState = {}

const middleware = [
    thunk
]

const reducers = combineReducers({
    qr: dataReducer,
    data: clienteReducer,
    user: userReducer
})

const store = createStore(
    reducers,
    initialState,
    compose(
        applyMiddleware(...middleware),
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
)

export default store